/**
 * Action for ticket selection of wizard view of a reservation.
 *
 * @class
 */
Sitepackage.Plugin.Reservation.WizardStepGroupInfoAction = (function () {
    /**
     * Initializes the action.
     *
     * @param {WizardAction} plugin Parent plugin
     * @param {Element} pluginContainer Parent plugin container
     * @param {Element} container Main container of the action
     *
     * @constructor
     */
    var WizardStepGroupInfoAction = function (plugin, pluginContainer, container) {
        const self = this;

        // Parent plugin
        this.plugin = plugin;

        // Parent plugin container
        this.pluginContainer = pluginContainer;

        // Main container of the action
        this.container = container;

        this.submitContainer = self.container.querySelector('.submit-row');
        this.submitContainer.classList.remove('d-none');

        this.reservationDataTemplate = this.container.querySelector('.reservation-data').cloneNode(true);
        this.reservationDataTemplate.classList.remove('reservation-data');


        this.groupNameField = this.container.querySelector('#groupname');
        this.guideCheckbox = this.container.querySelector('#reiseleiter2');
        this.austriaGuideCheckbox = this.container.querySelector('#austriaguide2');

        //this.initialize();

    };

    WizardStepGroupInfoAction.prototype.initialize = function (callback) {
        const self = this;

        GeneralUtility.showLoadingAnimationOfCard(self.container);

        self.hideHasDataHeader();

        self.groupNameField.addEventListener('blur', function () {
            self.plugin.setCurrentValue('groupName', self.groupNameField.value.trim());
            self.validateStep();
            self.updateHasDataHeader();
        });
        self.guideCheckbox.addEventListener('change', function () {
            self.plugin.setCurrentValue('hasGuide', self.guideCheckbox.checked);
            self.validateStep();
            self.updateHasDataHeader();
        });
        self.austriaGuideCheckbox.addEventListener('change', function () {
            self.plugin.setCurrentValue('hasAustriaGuide', self.austriaGuideCheckbox.checked);
            self.validateStep();
            self.updateHasDataHeader();
        });

        self.container.querySelectorAll('[data-toggle="tooltip"]').forEach(function (tooltip) {
            new Tooltip(tooltip);
        });

        self.prefill(function () {
            self.validateStep();

            GeneralUtility.hideLoadingAnimationOfCard(self.container);

            if (callback && typeof callback === 'function') {
                callback();
            }
        });
    };

    WizardStepGroupInfoAction.prototype.isOpen = function () {
        return this.container.classList.contains('card-active');
    };

    WizardStepGroupInfoAction.prototype.prefill = function (callback) {
        const self = this;
        var currentValues = self.plugin.getCurrentValues();

        self.updateHasDataHeader();
        if (self.hasData() && !self.isOpen()) {
            self.showHasDataHeader();
        }

        if (currentValues.groupName) {
            self.groupNameField.value = currentValues.groupName;
        }
        self.guideCheckbox.checked = currentValues.hasGuide;
        self.austriaGuideCheckbox.checked = currentValues.hasAustriaGuide;


        if (callback && typeof callback === 'function') {
            callback();
        }
    };

    /**
     * Does pre submit tasks and calls callback function afterwards
     *
     * @returns {void}
     */
    WizardStepGroupInfoAction.prototype.preSubmit = function (callback) {
        const self = this;


        if (callback && typeof callback === 'function') {
            callback();
        }


    };

    /**
     * Enables next button if all fields are filled correctly
     *
     * @returns {boolean}
     */
    WizardStepGroupInfoAction.prototype.validateStep = function () {
        const self = this;
        var valid = true;


        if (self.groupNameField.value.trim().length === 0) {
            valid = false;
            self.plugin.showError('groupName', 'Kein Gruppenname angegeben');
        } else {
            self.plugin.removeError('groupName');
        }

        if (!valid) {
            self.submitContainer.querySelector('.btn-next').setAttribute('disabled', 'disabled');
        } else {
            self.submitContainer.querySelector('.btn-next').removeAttribute('disabled');
        }
        self.setValidState(valid);
        self.plugin.toggleStateOfSubmitButton();
        return valid;
    };

    /**
     *
     * @param valid
     */
    WizardStepGroupInfoAction.prototype.setValidState = function (valid) {
        this.isValid = valid;
        this.container.dataset.valid = valid;
    };

    /**
     *
     * @returns {boolean}
     */
    WizardStepGroupInfoAction.prototype.getValidState = function () {
        return this.isValid;
    };

    /**
     *
     * Indicates if data was entered in the step. Used to modify the card header
     *
     * @returns {boolean}
     */
    WizardStepGroupInfoAction.prototype.hasData = function () {
        var currentValues = this.plugin.getCurrentValues();
        if (currentValues.groupName || currentValues.hasGuide || currentValues.hasAustriaGuide) {
            return true;
        }
        return false;
    };

    /**
     *
     * Hides entered data and shows the generic headline again
     *
     * @returns {void}
     */
    WizardStepGroupInfoAction.prototype.hideHasDataHeader = function () {
        this.container.classList.remove('card-data');
    };

    /**
     *
     * Modifies the card header.
     *
     * @returns {void}
     */
    WizardStepGroupInfoAction.prototype.updateHasDataHeader = function () {
        var currentValues = this.plugin.getCurrentValues();

        var dataContainer = this.container.querySelector('.card-header .reservation-data');
        if (this.hasData()) {

            var template = this.reservationDataTemplate.innerHTML;

            template = template.replace(/---field:groupName---/g, currentValues.groupName);
            dataContainer.innerHTML = template;
            if (!currentValues.groupName) {
                currentValues.groupName = '';
            }
            dataContainer.querySelector('[data-field-value="groupName"]').innerHTML = currentValues.groupName;
            if (currentValues.hasGuide) {
                dataContainer.querySelector('[data-field-checked="guide"]').classList.remove('card-not-selected');
                dataContainer.querySelector('[data-field-checked="guide"]').classList.add('card-selected');
            } else {
                dataContainer.querySelector('[data-field-checked="guide"]').classList.remove('card-selected');
                dataContainer.querySelector('[data-field-checked="guide"]').classList.add('card-not-selected');
            }
            if (currentValues.hasAustriaGuide) {
                dataContainer.querySelector('[data-field-checked="austria-guide"]').classList.remove('card-not-selected');
                dataContainer.querySelector('[data-field-checked="austria-guide"]').classList.add('card-selected');
            } else {
                dataContainer.querySelector('[data-field-checked="austria-guide"]').classList.remove('card-selected');
                dataContainer.querySelector('[data-field-checked="austria-guide"]').classList.add('card-not-selected');
            }

        }
    };

    /**
     *
     * Shows entered data instead of the generic headline
     *
     * @returns {void}
     */
    WizardStepGroupInfoAction.prototype.showHasDataHeader = function () {

        if (this.hasData()) {
            this.container.classList.add('card-data');
        } else {
            this.container.classList.remove('card-data');
        }
    };

    return WizardStepGroupInfoAction;
})();
